<script lang="ts" setup>
import { computed } from 'vue'
import { useWidgetStore } from '@/stores/widget'
import Snackbar, {
  Snackbar as SnackbarInterface
} from '@/components/Snackbar.vue'

const widgetStore = useWidgetStore()

const snackbarQueue = computed(() => widgetStore.snackbarQueue)

const destroySnackbar = (snackbar: SnackbarInterface) => {
  widgetStore.removeSnackbar(snackbar)
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed bottom-3 left-[50%] -translate-x-[50%] flex flex-col-reverse w-max max-w-[90%] sm:max-w-[80%] md:max-w-2xl mx-auto z-[100]"
    >
      <TransitionGroup
        move-class="transition-transform"
        enter-active-class="transition-transform duration-300"
        leave-active-class="transition-transform duration-300"
        enter-from-class="opacity-0 translate-y-8"
        leave-to-class="opacity-0 translate-y-8"
      >
        <Snackbar
          v-for="snackbar in snackbarQueue"
          :key="snackbar.id"
          class="my-1"
          :text="snackbar.text"
          :action-text="snackbar.actionText"
          :duration="snackbar.duration"
          :is-infinite="snackbar.isInfinite"
          :variant="snackbar.variant"
          @action="snackbar.action && snackbar.action()"
          @close="destroySnackbar(snackbar)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>
